import {resetContext} from 'kea'
import sagaPlugin from 'kea-saga'
import localStoragePlugin from 'kea-localstorage'
import { reducer as configReducer, actions as configActions } from './config'
import { spawn } from 'redux-saga/effects'

import { cartSaga } from "@gratify-eu/entities"

import saga from '~/scenes/saga'

function * rootSaga () {
  yield spawn(cartSaga);
  yield spawn(saga);
}

const appReducers = {
  config: configReducer,
};

const rootSagaPlugin = {
  name: 'rootSaga',

  // must be used globally
  global: true,
  local: false,

  events: {
    afterReduxStore: (options, store) => {
      if (store._sagaMiddleware) {
        store._sagaMiddleware.run(rootSaga);
      }
    },
  }
};

// export default getStore({
//   plugins: [ localStoragePlugin, sagaPlugin, rootSagaPlugin ],
//   paths: ['kea', 'scenes', 'entities', 'root', 'plugins'],
//   reducers: appReducers
// })

const context = resetContext({ // <----------------------------------- add this
  createStore: {
    paths: ['kea', 'scenes', 'entities', 'root', 'plugins'],
    reducers: appReducers,
  },
  plugins: [
    localStoragePlugin, sagaPlugin, rootSagaPlugin
  ]
});
export default context.store;
